import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider 
    clientId='71212262947-q7c9m00c23qsvm03jmg3at53krp89ulc.apps.googleusercontent.com'
    onScriptLoadError={() => console.error('Failed to load Google Identity Services script')}
    onScriptLoadSuccess={() => console.log('Google Identity Services script loaded successfully')}
  >
    <App />
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
